import React from 'react';

import { images } from '../../constants';
import './Header.css';
import { SubHeading } from '../../components';

const Header = () => (
  <div className="app__header app__wrapper section__padding" id="home">
   <div className="app__wrapper_info">
    <SubHeading title="Chase the new flavour"/>
    <h1 className="app__header-h1">The key to Fine Dining </h1>
    <p className="p__opensans" style={{margin:'2rem 0'}}>Your belly knows best.Chicken dinner is a winner Grab life by the fork.Eat outside the box.Eat a lot today (and again tomorrow).Burgers! Because no great story started with salad</p>
    <button type="button" className="custom__button">Explore Menu</button>
   </div>

   <div className="app__wrapper_img">
    <img src={images.welcome} alt="header img"/>

   </div>
  </div>
);

export default Header;
